import { render, staticRenderFns } from "./UpgradeNowButton.vue?vue&type=template&id=d4366e5a&"
import script from "./UpgradeNowButton.vue?vue&type=script&lang=ts&"
export * from "./UpgradeNowButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports